import { render, staticRenderFns } from "./StockTotals.vue?vue&type=template&id=54f06e56&lang=pug"
import script from "./StockTotals.vue?vue&type=script&lang=js"
export * from "./StockTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports